import React from 'react';
import dropdownBlack from 'assets/images/dropdown-black.svg';
import dropdownWhite from 'assets/images/dropdown-white.svg';
import {
  Button,
  Menu,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
  Image
} from '@fluentui/react-components';
import TriviaLogo from 'assets/images/logo.svg';
import WhiteTriviaLogo from 'assets/images/white-trivia-logo.svg';
import phone from 'assets/images/phone.svg';
import lightDashboard from 'assets/images/light-dashboard.svg';
import lightPhone from 'assets/images/light-phone.svg';
import dashboard from 'assets/images/dashboard.svg';
import successStories from 'assets/images/success-stories.svg';
import lightSuccessStories from 'assets/images/light-success-stories.svg';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { BASIC } from 'redux/types';
import styles from './MobileHeader.module.scss';

const MobileHeader = (props) => {
  const { darkTheme, plan, freeTrial } = props;
  const dashboardUrl = process.env.REACT_APP_DASHBOARD_URL;
  const demoUrl = 'https://api-trivia-teams.trytrivia.co/demo';

  const handleMenuItemClick = (content) => {
    if (content === 'Dashboard') {
      window.open(dashboardUrl);
    } else if (content === 'Success Stories') {
      window.open(`${process.env.REACT_APP_HOME_PAGE}customers`);
    } else {
      window.open(demoUrl);
    }
  };

  const menuItems = [
    {
      key: 'dashboardOrDemo',
      content: freeTrial || plan === BASIC ? 'Book a demo' : 'Dashboard',
      icon: (
        <Image
          src={darkTheme ? (freeTrial || plan === BASIC ? lightPhone : lightDashboard) : (freeTrial || plan === BASIC ? phone : dashboard)}
          alt='Icon'
          className={styles.img}
        />
      )
    },
    {
      key: 'successStories',
      content: 'Success Stories',
      icon: (
        <Image
          src={darkTheme ? lightSuccessStories : successStories}
          alt='Success Stories'
          className={styles.img}
        />
      )
    }
  ];

  return (
    <div className={classNames(styles.headerWrapper, { [styles.darkTheme]: darkTheme })}>
      <div className={styles.flexContainer}>
        <div className={styles.logo}>
          <img src={darkTheme ? WhiteTriviaLogo : TriviaLogo} alt='trivia' />
        </div>
        <div className={styles.buttonContainer}>
          <Button
            icon={
              freeTrial || plan === BASIC ? (
                <Image src={lightPhone} alt='phone icon' />
              ) : (
                <Image src={lightDashboard} alt='dashboard icon' />
              )
            }
            className={styles.button}
            onClick={() =>
              freeTrial || plan === BASIC ? window.open(demoUrl) : window.open(dashboardUrl)
            }
            appearance='primary'
          >
            {freeTrial || plan === BASIC ? 'Book a demo' : 'View Dashboard'}
          </Button>
          <Menu>
            <MenuTrigger className={styles.menu}>
              <Image src={darkTheme ? dropdownWhite : dropdownBlack} alt='menu' />
            </MenuTrigger>
            <MenuPopover>
              <MenuList>
                {menuItems.map(({ key, content, icon }) => (
                  <MenuItem key={key} onClick={() => handleMenuItemClick(content)}>
                    <>
                      {icon}
                      {content}
                    </>
                  </MenuItem>
                ))}
              </MenuList>
            </MenuPopover>
          </Menu>
        </div>
      </div>
    </div>
  );
};

MobileHeader.propTypes = {
  darkTheme: PropTypes.bool,
  plan: PropTypes.string.isRequired,
  freeTrial: PropTypes.bool.isRequired
};

MobileHeader.defaultProps = {
  darkTheme: false
};
export default MobileHeader;
